export default {
  isUnique(value, target) {
    if (target === undefined || target === null) {
      return true;
    }

    let newTarget = Array.isArray(target) ? target : [target];
    return newTarget.includes(value) ? false : true;
  }
}